import React, { useEffect, useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import ModalAlert from '../helpers/ModalAlert';
import { UIProperties } from '../UIProperties';

import './ModalPopUI.css'
const ModalPopUI = (props: UIProperties<ModalPopUIConfig>) => {
	return (
		<div id={props.id} className="modal-bg fade-in-animation in-game-ui-container ui-top-most-container dialogueui-container modal-disable-select">
			<div>
				<ModalAlert id="directions-ui-alert" dispatch={props.dispatch} parameters={{
					title: props.parameters.title,
					text: props.parameters.text,
					smallerTitle: false,
					useBigText: true, 
					onContinueClicked: () => {
						var el = document.getElementById(props.id);
						el.classList.remove('fade-in-animation');
						el.classList.add('fade-out-animation');
						setTimeout(() => {
							props.parameters.onContinueClicked() 
						}, 500);
					}
				}}></ModalAlert>
			</div>
		</div>
	);

};

export interface ModalPopUIConfig extends BaseConfig {
	title?: string;
	text: string;
	onContinueClicked: () => void;
}

export default ModalPopUI;